(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dof-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.getAttribute('data-dof-contact-bound') === '1') return;
      root.setAttribute('data-dof-contact-bound', '1');

      /* Zeichenzähler */
      var body = root.querySelector('[data-dof-contact-body]');
      var count = root.querySelector('[data-dof-contact-count]');
      if (body && count) {
        var update = function () {
          count.textContent = body.value.length;
        };
        body.addEventListener('input', update);
        update();
      }

      /* "Wird gesendet"-Zustand beim Absenden (das Formular sendet ganz normal) */
      var form = root.querySelector('[data-dof-contact-form]');
      var submit = root.querySelector('[data-dof-contact-submit]');
      if (form && submit) {
        form.addEventListener('submit', function () {
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
          submit.classList.add('is-busy');
        });
        window.addEventListener('pageshow', function () {
          submit.classList.remove('is-busy');
        });
      }

      /* Lichtkegel folgt der Maus auf der Formular-Karte */
      var card = root.querySelector('[data-dof-contact-card]');
      if (card && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var frame = null;
        card.addEventListener('pointermove', function (event) {
          if (frame) return;
          frame = window.requestAnimationFrame(function () {
            frame = null;
            var rect = card.getBoundingClientRect();
            card.style.setProperty('--mx', (((event.clientX - rect.left) / rect.width) * 100).toFixed(1) + '%');
            card.style.setProperty('--my', (((event.clientY - rect.top) / rect.height) * 100).toFixed(1) + '%');
          });
        });
      }
    }

    function setupAll() {
      document.querySelectorAll('[data-dof-contact]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dof-legal-link-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-dof-cookie-preferences]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      window.Shopify.customerPrivacy.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dof-manifest-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function setup(root) {
      if (!root || root.getAttribute('data-dof-ms-ready') === '1') return;
      root.setAttribute('data-dof-ms-ready', '1');

      var words = [].slice.call(root.querySelectorAll('.dof-ms__w'));
      var pct = root.querySelector('[data-ms-pct]');
      var sig = root.querySelector('[data-ms-sig]');
      var last = [];
      var nowIndex = -1;
      var hotFrom = -1;
      var ticking = false;
      if (!words.length) return;

      /* Signatur in Buchstaben zerlegen (für den Tipp-Effekt) */
      if (sig) {
        var label = sig.textContent;
        sig.setAttribute('aria-label', label);
        sig.textContent = '';
        label.split('').forEach(function (char, k) {
          var span = document.createElement('span');
          span.setAttribute('aria-hidden', 'true');
          span.style.setProperty('--k', k);
          span.textContent = char;
          sig.appendChild(span);
        });
      }

      function update() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > vh) return;

        var scrollable = rect.height - vh;
        var p = scrollable > 0 ? Math.min(Math.max(-rect.top / scrollable, 0), 1) : 1;
        root.style.setProperty('--ms-p', p.toFixed(4));

        /* Text ist bei ~85 % komplett an */
        var done = Math.min(p / 0.85, 1);
        var t = done * words.length;
        var now = -1;
        for (var i = 0; i < words.length; i++) {
          var l = Math.min(Math.max(t - i, 0), 1);
          var rounded = Math.round(l * 50) / 50;
          if (last[i] !== rounded) {
            words[i].style.setProperty('--l', rounded);
            last[i] = rounded;
          }
          if (l > 0 && l < 1) now = i;
        }

        if (now !== nowIndex) {
          if (nowIndex > -1) words[nowIndex].classList.remove('is-now');
          if (now > -1) words[now].classList.add('is-now');
          nowIndex = now;
        }

        /* Glut: aktuelles + vorheriges Wort glühen */
        var head = Math.floor(t);
        if (head !== hotFrom) {
          hotFrom = head;
          words.forEach(function (word, index) {
            word.classList.toggle('is-hot', done < 1 && (index === head || index === head - 1) && !word.classList.contains('is-key'));
          });
        }

        if (pct) {
          var value = Math.round(done * 100);
          pct.textContent = value < 10 ? '0' + value : String(value);
        }
        root.classList.toggle('is-done', p >= 0.86);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function setupAll() {
      document.querySelectorAll('[data-dof-ms]').forEach(setup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll);
    else setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dof-tiktok"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CONSENT_KEY = 'dof_tiktok_consent';
    var EMBED_SCRIPT = 'https://www.tiktok.com/embed.js';
    /* fullscreen_button=0: statt echtem Vollbild vergrößert der eigene Button die Karte */
    var PLAYER_PARAMS =
      'autoplay=1&controls=1&progress_bar=1&play_button=1&volume_control=1&fullscreen_button=0' +
      '&timestamp=1&loop=0&music_info=0&description=0&rel=0&native_context_menu=0&closed_caption=0';

    function hasConsent() {
      try {
        if (localStorage.getItem(CONSENT_KEY) === '1') return true;
      } catch (e) {}
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed()) return true;
      } catch (e) {}
      return false;
    }

    function rememberConsent() {
      try {
        localStorage.setItem(CONSENT_KEY, '1');
      } catch (e) {}
    }

    function loadEmbedScript() {
      var old = document.querySelector('script[data-dof-tt-embed]');
      if (old) old.remove();
      var script = document.createElement('script');
      script.src = EMBED_SCRIPT;
      script.async = true;
      script.setAttribute('data-dof-tt-embed', '');
      document.body.appendChild(script);
    }

    function fetchOembed(url) {
      return fetch('https://www.tiktok.com/oembed?url=' + encodeURIComponent(url)).then(function (res) {
        if (!res.ok) throw new Error('oembed ' + res.status);
        return res.json();
      });
    }

    /* ── Vergrößern: Karte fliegt (FLIP) in die Bildschirmmitte, der Player bleibt im DOM → kein Neustart ── */
    var EXPAND_MS = 650;

    function targetRect() {
      var vw = document.documentElement.clientWidth;
      var vh = window.innerHeight;
      var mobile = vw < 750;
      var maxH = vh - (mobile ? 120 : 150);
      var w = Math.min(mobile ? vw * 0.9 : 460, (maxH * 9) / 16);
      var h = (w * 16) / 9;
      return { left: (vw - w) / 2, top: Math.max(56, (vh - h) / 2 + 20), width: w };
    }

    function expandCard(root, card) {
      if (card.classList.contains('is-expanded') || !card.classList.contains('is-playing')) return;
      var item = card.closest('.dof-tt__item');
      var frame = card.querySelector('.dof-tt__frame');
      var from = frame.getBoundingClientRect();
      var to = targetRect();

      item.style.height = item.offsetHeight + 'px';
      card.style.setProperty('--dof-tt-x', to.left + 'px');
      card.style.setProperty('--dof-tt-y', to.top + 'px');
      card.style.setProperty('--dof-tt-w', to.width + 'px');

      card.style.transition = 'none';
      card.classList.add('is-expanded');
      card.style.transform =
        'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + from.width / to.width + ')';
      void card.offsetWidth;
      card.style.transition = '';
      card.style.transform = '';

      root.classList.add('has-expanded');
      document.documentElement.classList.add('dof-tt-lock');
      var btn = card.querySelector('[data-dof-tt-expand]');
      if (btn) {
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Video verkleinern');
      }
    }

    function collapseCard(root, card, instant) {
      if (!card || !card.classList.contains('is-expanded')) return Promise.resolve();
      var item = card.closest('.dof-tt__item');
      var to = item.getBoundingClientRect();
      var cur = card.querySelector('.dof-tt__frame').getBoundingClientRect();

      root.classList.remove('has-expanded');
      document.documentElement.classList.remove('dof-tt-lock');
      var btn = card.querySelector('[data-dof-tt-expand]');
      if (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Video vergrößern');
      }

      function finish() {
        card.classList.remove('is-expanded');
        card.style.transition = '';
        card.style.transform = '';
        card.style.removeProperty('--dof-tt-x');
        card.style.removeProperty('--dof-tt-y');
        card.style.removeProperty('--dof-tt-w');
        item.style.height = '';
      }

      if (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return Promise.resolve();
      }

      card.style.transform =
        'translate(' + (to.left - cur.left) + 'px,' + (to.top - cur.top) + 'px) scale(' + to.width / cur.width + ')';

      return new Promise(function (resolve) {
        window.setTimeout(function () {
          finish();
          resolve();
        }, EXPAND_MS);
      });
    }

    function stopCard(card) {
      if (!card) return;
      var root = card.closest('[data-dof-tiktok]');
      if (card.classList.contains('is-expanded')) {
        collapseCard(root, card).then(function () {
          stopCard(card);
        });
        return;
      }
      var player = card.querySelector('[data-dof-tt-player]');
      card.classList.remove('is-playing');
      window.setTimeout(function () {
        if (!card.classList.contains('is-playing') && player) player.innerHTML = '';
      }, 450);
    }

    function playCard(root, card) {
      var id = card.getAttribute('data-video-id');
      var url = card.getAttribute('data-url');
      if (!id) {
        window.open(url, '_blank', 'noopener');
        return;
      }

      root.querySelectorAll('[data-dof-tt-card].is-playing').forEach(function (other) {
        if (other !== card) stopCard(other);
      });

      var player = card.querySelector('[data-dof-tt-player]');
      var fallback = card.querySelector('[data-dof-tt-fallback]');
      if (fallback) fallback.hidden = true;

      player.innerHTML =
        '<iframe src="https://www.tiktok.com/player/v1/' + id + '?' + PLAYER_PARAMS +
        '" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="TikTok-Video"></iframe>';
      card.classList.add('is-playing');

      /* Handy: Karten sind klein (2 × 2) → beim Abspielen automatisch groß in die Mitte */
      if (window.matchMedia('(max-width: 749px)').matches) {
        window.requestAnimationFrame(function () {
          expandCard(root, card);
        });
      }
    }

    function initTilt(card) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var frame = null;
      card.addEventListener('pointermove', function (event) {
        if (card.classList.contains('is-playing') || frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          var rect = card.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width;
          var y = (event.clientY - rect.top) / rect.height;
          card.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
      });
    }

    function initVideos(root) {
      root.querySelectorAll('[data-dof-tt-card]').forEach(function (card) {
        var url = card.getAttribute('data-url');

        fetchOembed(url)
          .then(function (data) {
            var thumb = card.querySelector('.dof-tt__thumb');
            var title = card.querySelector('[data-dof-tt-title]');
            if (data.embed_product_id) card.setAttribute('data-video-id', data.embed_product_id);
            if (title) title.textContent = data.title || '';
            if (data.thumbnail_url && thumb) {
              var img = new Image();
              img.onload = function () {
                thumb.style.backgroundImage = 'url("' + data.thumbnail_url + '")';
                card.classList.remove('is-loading');
              };
              img.onerror = function () {
                card.classList.remove('is-loading');
              };
              img.src = data.thumbnail_url;
            } else {
              card.classList.remove('is-loading');
            }
          })
          .catch(function () {
            card.classList.remove('is-loading');
            var title = card.querySelector('[data-dof-tt-title]');
            if (title) title.textContent = 'Video auf TikTok ansehen';
          });

        card.querySelector('[data-dof-tt-play]').addEventListener('click', function () {
          playCard(root, card);
        });

        card.querySelector('[data-dof-tt-stop]').addEventListener('click', function () {
          stopCard(card);
        });

        card.querySelector('[data-dof-tt-expand]').addEventListener('click', function () {
          if (card.classList.contains('is-expanded')) {
            collapseCard(root, card);
          } else {
            expandCard(root, card);
          }
        });

        initTilt(card);
      });

      var backdrop = root.querySelector('[data-dof-tt-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          collapseCard(root, root.querySelector('[data-dof-tt-card].is-expanded'));
        });
      }
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-dof-tt-card].is-expanded').forEach(function (card) {
        collapseCard(card.closest('[data-dof-tiktok]'), card);
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-dof-tt-card].is-expanded').forEach(function (card) {
        var to = targetRect();
        card.style.setProperty('--dof-tt-x', to.left + 'px');
        card.style.setProperty('--dof-tt-y', to.top + 'px');
        card.style.setProperty('--dof-tt-w', to.width + 'px');
      });
    });

    /* Fehler-Meldungen des TikTok-Players -> Fallback-Link in der Karte zeigen */
    window.addEventListener('message', function (event) {
      var host = '';
      try {
        host = new URL(event.origin).hostname;
      } catch (e) {
        return;
      }
      if (!/(^|\.)tiktok\.com$/.test(host)) return;
      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      if (!data || !data['x-tiktok-player'] || data.type !== 'onError') return;
      document.querySelectorAll('[data-dof-tt-card].is-playing').forEach(function (card) {
        var iframe = card.querySelector('iframe');
        if (iframe && iframe.contentWindow === event.source) {
          var fallback = card.querySelector('[data-dof-tt-fallback]');
          if (fallback) fallback.hidden = false;
        }
      });
    });

    function initProfile(root) {
      var frame = root.querySelector('[data-dof-tt-profile]');
      var username = root.getAttribute('data-username');
      if (!frame || !username) return;
      frame.innerHTML =
        '<blockquote class="tiktok-embed" cite="https://www.tiktok.com/@' + username +
        '" data-unique-id="' + username + '" data-embed-type="creator" style="max-width:780px;min-width:288px;">' +
        '<section><a target="_blank" rel="noopener" href="https://www.tiktok.com/@' + username +
        '?refer=creator_embed">@' + username + '</a></section></blockquote>';
      loadEmbedScript();
    }

    function reveal(root) {
      if (root.getAttribute('data-dof-tt-ready') === '1') return;
      root.setAttribute('data-dof-tt-ready', '1');
      root.classList.add('is-unlocked');
      if (root.getAttribute('data-mode') === 'profile') {
        initProfile(root);
      } else {
        initVideos(root);
      }
    }

    function setup(root) {
      if (!root || root.getAttribute('data-dof-tt-bound') === '1') return;
      root.setAttribute('data-dof-tt-bound', '1');

      var button = root.querySelector('[data-dof-tt-load]');
      if (button) {
        button.addEventListener('click', function () {
          rememberConsent();
          document.querySelectorAll('[data-dof-tiktok]').forEach(reveal);
        });
      }

      if (root.getAttribute('data-load') === 'auto' || hasConsent()) {
        reveal(root);
      }
    }

    function setupAll() {
      document.querySelectorAll('[data-dof-tiktok]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
